import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { svg } from "lit";
//#region src/pd-icon/iconset.ts
var iconset_exports = /* @__PURE__ */ __exportAll({
	ALL_ICONS: () => ALL_ICONS,
	EMPTY_POLYGON: () => EMPTY_POLYGON,
	ICON_ADD: () => ICON_ADD,
	ICON_AI_SPARKLE: () => ICON_AI_SPARKLE,
	ICON_ALIGN_CENTER: () => ICON_ALIGN_CENTER,
	ICON_ALIGN_LEFT: () => ICON_ALIGN_LEFT,
	ICON_ALIGN_RIGHT: () => ICON_ALIGN_RIGHT,
	ICON_ARROW_BACK: () => ICON_ARROW_BACK,
	ICON_ARROW_DOWN: () => ICON_ARROW_DOWN,
	ICON_ARROW_NEXT: () => ICON_ARROW_NEXT,
	ICON_ARROW_UP: () => ICON_ARROW_UP,
	ICON_AVAILABILITY: () => ICON_AVAILABILITY,
	ICON_BLOCKQUOTE: () => ICON_BLOCKQUOTE,
	ICON_BURGER_MENU: () => ICON_BURGER_MENU,
	ICON_CAMERA: () => ICON_CAMERA,
	ICON_CANCEL: () => ICON_CANCEL,
	ICON_CHAT: () => ICON_CHAT,
	ICON_CHECK: () => ICON_CHECK,
	ICON_CHECKBOX: () => ICON_CHECKBOX,
	ICON_CHECKBOX_ONLY_CHECK: () => ICON_CHECKBOX_ONLY_CHECK,
	ICON_CIRCLE: () => ICON_CIRCLE,
	ICON_CLOCK: () => ICON_CLOCK,
	ICON_CLOSE: () => ICON_CLOSE,
	ICON_CLOUD_DOWNLOAD: () => ICON_CLOUD_DOWNLOAD,
	ICON_CLOUD_UPLOAD: () => ICON_CLOUD_UPLOAD,
	ICON_CODE: () => ICON_CODE,
	ICON_CODE_BLOCK: () => ICON_CODE_BLOCK,
	ICON_COPY: () => ICON_COPY,
	ICON_DATE: () => ICON_DATE,
	ICON_DATE_TIME: () => ICON_DATE_TIME,
	ICON_DELETE: () => ICON_DELETE,
	ICON_DELETE_NEW: () => ICON_DELETE_NEW,
	ICON_DETAIL: () => ICON_DETAIL,
	ICON_DRAG_HANDLE: () => ICON_DRAG_HANDLE,
	ICON_EDIT: () => ICON_EDIT,
	ICON_EDIT_NEW: () => ICON_EDIT_NEW,
	ICON_ERROR: () => ICON_ERROR,
	ICON_ERROR_FLD: () => ICON_ERROR_FLD,
	ICON_EYE: () => ICON_EYE,
	ICON_HELP: () => ICON_HELP,
	ICON_HELP_FLD: () => ICON_HELP_FLD,
	ICON_HORIZONTAL_RULE: () => ICON_HORIZONTAL_RULE,
	ICON_INFO: () => ICON_INFO,
	ICON_INFO_FLD: () => ICON_INFO_FLD,
	ICON_LEAVE: () => ICON_LEAVE,
	ICON_LINK: () => ICON_LINK,
	ICON_MAIL: () => ICON_MAIL,
	ICON_NEXT: () => ICON_NEXT,
	ICON_PHONE: () => ICON_PHONE,
	ICON_PREVIOUS: () => ICON_PREVIOUS,
	ICON_RULES: () => ICON_RULES,
	ICON_SEARCH: () => ICON_SEARCH,
	ICON_SETTINGS: () => ICON_SETTINGS,
	ICON_STAR: () => ICON_STAR,
	ICON_STAT: () => ICON_STAT,
	ICON_SYNC: () => ICON_SYNC,
	ICON_TOGGLE_COLLAPSE: () => ICON_TOGGLE_COLLAPSE,
	ICON_TOOGLE_ARROW: () => ICON_TOOGLE_ARROW,
	ICON_USER: () => ICON_USER,
	ICON_USERS: () => ICON_USERS,
	ICON_WARNING: () => ICON_WARNING,
	ICON_WARNING_FLD: () => ICON_WARNING_FLD,
	ICON_XCLOSE: () => ICON_XCLOSE,
	iconset: () => iconset
});
/**
* Export names of all available icons (access from outside by name).
*/
var ICON_CLOSE = "closeLink";
var ICON_XCLOSE = "xCloseIcon";
/** Statisches Häkchen (kein Morph — für Bestätigen-Aktionen). */
var ICON_CHECK = "checkIcon";
/** Statisches X (kein Morph — für Abbrechen/Schließen-Aktionen). */
var ICON_CANCEL = "cancelIcon";
var ICON_ARROW_BACK = "arrowBack";
var ICON_ARROW_NEXT = "arrowNext";
var ICON_ARROW_UP = "arrowUp";
var ICON_ARROW_DOWN = "arrowDown";
var ICON_TOGGLE_COLLAPSE = "toggleCollapse";
var ICON_TOOGLE_ARROW = "toggleArrow";
var ICON_CHECKBOX = "checkBox";
var ICON_CHECKBOX_ONLY_CHECK = "checkBoxOnlyCheck";
var ICON_ADD = "addIcon";
var ICON_NEXT = "nextArrow";
var ICON_PREVIOUS = "previousArrow";
var ICON_STAR = "starIcon";
var ICON_CAMERA = "cameraIcon";
var ICON_DELETE = "deleteIcon";
var ICON_DELETE_NEW = "deleteIcon2";
var ICON_SETTINGS = "settingsIcon";
var ICON_RULES = "rulesIcon";
var ICON_USER = "userIcon";
var ICON_USERS = "usersIcon";
/** Sprechblase — Chat, Nachrichten, Kommentare. */
var ICON_CHAT = "chatIcon";
var ICON_LEAVE = "leaveGame";
var ICON_STAT = "statIcon";
var ICON_SYNC = "syncIcon";
var ICON_CLOUD_UPLOAD = "cloudUploadIcon";
var ICON_CLOUD_DOWNLOAD = "cloudDownloadIcon";
var ICON_DATE = "dateIcon";
var ICON_DATE_TIME = "dateTimeIcon";
var ICON_AVAILABILITY = "availabilityIcon";
var ICON_CLOCK = "clockIcon";
var ICON_DETAIL = "detailIcon";
var ICON_ERROR = "errorIcon";
var ICON_ERROR_FLD = "errorIconFld";
var ICON_HELP = "helpIcon";
var ICON_HELP_FLD = "helpIconFld";
var ICON_INFO = "infoIcon";
var ICON_INFO_FLD = "infoIconFld";
var ICON_WARNING = "warningIcon";
var ICON_WARNING_FLD = "warningIconFld";
var ICON_BURGER_MENU = "burgerMenuIcon";
var ICON_DRAG_HANDLE = "dragHandleIcon";
var ICON_EDIT = "editIcon";
var ICON_EDIT_NEW = "editIcon2";
var ICON_SEARCH = "searchIcon";
var ICON_PHONE = "phoneIcon";
var ICON_MAIL = "mailIcon";
var ICON_CIRCLE = "circleIcon";
var ICON_AI_SPARKLE = "aiSparkleIcon";
var ICON_COPY = "copyIcon";
var ICON_ALIGN_LEFT = "alignLeftIcon";
var ICON_ALIGN_CENTER = "alignCenterIcon";
var ICON_ALIGN_RIGHT = "alignRightIcon";
var ICON_LINK = "linkIcon";
var ICON_CODE = "codeIcon";
var ICON_CODE_BLOCK = "codeBlockIcon";
var ICON_BLOCKQUOTE = "blockquoteIcon";
var ICON_HORIZONTAL_RULE = "horizontalRuleIcon";
var ICON_EYE = "eyeIcon";
var ALL_ICONS = [
	ICON_CLOSE,
	ICON_XCLOSE,
	ICON_CHECK,
	ICON_CANCEL,
	ICON_ARROW_BACK,
	ICON_ARROW_NEXT,
	ICON_ARROW_UP,
	ICON_ARROW_DOWN,
	ICON_TOGGLE_COLLAPSE,
	ICON_TOOGLE_ARROW,
	ICON_CHECKBOX,
	ICON_CHECKBOX_ONLY_CHECK,
	ICON_ADD,
	ICON_NEXT,
	ICON_PREVIOUS,
	ICON_STAR,
	ICON_CAMERA,
	ICON_DELETE,
	ICON_DELETE_NEW,
	ICON_SETTINGS,
	ICON_RULES,
	ICON_USER,
	ICON_USERS,
	ICON_CHAT,
	ICON_LEAVE,
	ICON_STAT,
	ICON_SYNC,
	ICON_CLOUD_UPLOAD,
	ICON_CLOUD_DOWNLOAD,
	ICON_DATE,
	ICON_DATE_TIME,
	ICON_AVAILABILITY,
	ICON_CLOCK,
	ICON_DETAIL,
	ICON_ERROR,
	ICON_ERROR_FLD,
	ICON_HELP,
	ICON_HELP_FLD,
	ICON_INFO,
	ICON_INFO_FLD,
	ICON_WARNING,
	ICON_WARNING_FLD,
	ICON_BURGER_MENU,
	ICON_DRAG_HANDLE,
	ICON_EDIT,
	ICON_EDIT_NEW,
	ICON_SEARCH,
	ICON_PHONE,
	ICON_MAIL,
	ICON_CIRCLE,
	ICON_AI_SPARKLE,
	ICON_COPY,
	ICON_ALIGN_LEFT,
	ICON_ALIGN_CENTER,
	ICON_ALIGN_RIGHT,
	ICON_LINK,
	ICON_CODE,
	ICON_CODE_BLOCK,
	ICON_BLOCKQUOTE,
	ICON_HORIZONTAL_RULE,
	ICON_EYE
];
/**
* svg path definitions for dynamic icons.
*/
var arrowBack = "14.83 3.99 11.84 1 7.84 5 4.84 8 0.84 12 4.84 16 11.84 23 14.87 20.03 8.96 14.14 23.16 14.14 23.16 9.99 8.86 9.97 14.83 3.99";
var iconPlus = "21 10 14 10 14 3 10 3 10 10 3 10 3 14 10 14 10 21 14 21 14 14 21 14 21 10";
var iconMinus = "21 11.52 21 9.97 14 9.97 10 9.97 3 9.97 3 11.52 3 12.41 3 13.97 10 13.97 14 13.97 21 13.97 21 12.41 21 11.52";
var iconSquare = "21 10.24 21 3.24 14 3.24 10 3.24 3 3.24 3 10.24 3 14.24 3 21.24 10 21.24 14 21.24 21 21.24 21 14.24 21 10.24";
var iconCross = "16.95 4.22 12 9.17 7.05 4.22 4.22 7.05 9.17 12 4.22 16.95 7.05 19.78 12 14.83 16.95 19.78 19.78 16.95 14.83 12 19.78 7.05 16.95 4.22";
var iconRhombusH = "16 5 12 1 8 5 5 8 1 12 5 16 8 19 12 23 16 19 19 16 23 12 19 8 16 5";
var iconRhombusV = "19 16 23 12 21 10 20 9 12 1 4 9 3 10 1 12 5 16 8 19 12 23 16 19 19 16";
var iconArrowRight = "13 4.97 9 0.97 7 2.97 6 3.97 14 11.97 6 19.97 7 20.97 9 22.97 13 18.97 16 15.97 20 11.97 16 7.97 13 4.97";
var iconArrowLeft = "17 2.97 15 0.97 11 4.97 8 7.97 4 11.97 8 15.97 11 18.97 15 22.97 17 20.97 18 19.97 10 11.97 18 3.97 17 2.97";
var iconArrowUp = "21 17 23 14.97 21 12.97 20 11.97 12 3.97 4 11.97 3 12.97 1 14.97 2 16 4 18 12 10 20 18 21 17";
var iconArrowDown = "19 13 23 9 21 7 20 6 12 14 4 6 3 7 1 9 5 13 8 16 12 20 16 16 19 13";
var iconCheck = "20 3.5 9 14.5 4 9.5 3 10.5 1 12.5 5 16.5 5 16.5 9 20.5 13 16.5 16 13.5 23 6.5 22 5.5 20 3.5";
var iconStar = "13.48 5.84 12 2.85 10.55 5.85 9 8.85 2.38 9.84 7.19 14.53 6.05 21.15 12 18.02 17.95 21.15 16.81 14.53 21.62 9.84 14.97 8.87 13.48 5.84";
var iconCircle = "12 2 14.6 2.4 16.9 3.4 18.9 4.9 20.5 6.9 21.5 9.3 21.9 12 21.5 14.7 20.5 17.1 18.9 19.1 16.9 20.6 14.6 21.6 12 22 9.4 21.6 7.1 20.6 5.1 19.1 3.5 17.1 2.5 14.7 2.1 12 2.5 9.3 3.5 6.9 5.1 4.9 7.1 3.4 9.4 2.4 12 2";
var EMPTY_POLYGON = "0 0 0 0 0 0";
var iconset = {
	[ICON_CLOSE]: {
		cssClass: "close-link",
		state: {
			activ: iconCross,
			activAn: `${iconCross};${iconRhombusH};${iconArrowRight}`,
			inactiv: iconArrowRight,
			inActivAn: `${iconArrowRight};${iconRhombusH};${iconCross}`
		}
	},
	[ICON_XCLOSE]: {
		cssClass: "x-close",
		state: {
			activ: iconArrowLeft,
			activAn: `${iconArrowLeft};${iconRhombusH};${iconCross}`,
			inactiv: iconArrowLeft,
			inActivAn: `${iconCross};${iconRhombusH};${iconArrowLeft}`
		}
	},
	[ICON_CHECK]: {
		cssClass: "checkbox",
		state: {
			activ: iconCheck,
			activAn: `${iconCheck};${iconCheck}`,
			inactiv: iconCheck,
			inActivAn: `${iconCheck};${iconCheck}`
		}
	},
	[ICON_CANCEL]: {
		cssClass: "x-close",
		state: {
			activ: iconCross,
			activAn: `${iconCross};${iconCross}`,
			inactiv: iconCross,
			inActivAn: `${iconCross};${iconCross}`
		}
	},
	[ICON_ARROW_BACK]: {
		cssClass: "arrow-back",
		state: {
			activ: arrowBack,
			activAn: `${arrowBack};${iconRhombusH};${arrowBack}`,
			inactiv: arrowBack,
			inActivAn: `${arrowBack};${iconRhombusH};${arrowBack}`
		}
	},
	[ICON_ARROW_NEXT]: {
		cssClass: "arrow-next",
		state: {
			activ: arrowBack,
			activAn: `${arrowBack};${iconRhombusH};${arrowBack}`,
			inactiv: arrowBack,
			inActivAn: `${arrowBack};${iconRhombusH};${arrowBack}`
		}
	},
	[ICON_ARROW_UP]: {
		cssClass: "arrow-up",
		state: {
			activ: iconArrowUp,
			activAn: `${iconArrowUp};${iconRhombusV};${iconArrowUp}`,
			inactiv: iconArrowUp,
			inActivAn: `${iconArrowUp};${iconRhombusV};${iconArrowUp}`
		}
	},
	[ICON_ARROW_DOWN]: {
		cssClass: "arrow-down",
		state: {
			activ: iconArrowDown,
			activAn: `${iconArrowDown};${iconRhombusV};${iconArrowDown}`,
			inactiv: iconArrowDown,
			inActivAn: `${iconArrowDown};${iconRhombusV};${iconArrowDown}`
		}
	},
	[ICON_TOGGLE_COLLAPSE]: {
		cssClass: "toggle-collapse",
		state: {
			activ: iconPlus,
			activAn: `${iconPlus};${iconSquare};${iconMinus}`,
			inactiv: iconMinus,
			inActivAn: `${iconMinus};${iconSquare};${iconPlus}`
		}
	},
	[ICON_TOOGLE_ARROW]: {
		cssClass: "toggle-arrow",
		state: {
			activ: iconArrowUp,
			activAn: `${iconArrowUp};${iconRhombusV};${iconArrowDown}`,
			inactiv: iconArrowDown,
			inActivAn: `${iconArrowDown};${iconRhombusV};${iconArrowUp}`
		}
	},
	[ICON_CHECKBOX]: {
		cssClass: "checkbox",
		state: {
			activ: iconCheck,
			activAn: `${iconCross};${iconRhombusH};${iconCheck}`,
			inactiv: iconCross,
			inActivAn: `${iconCheck};${iconRhombusH};${iconCross}`
		}
	},
	[ICON_CHECKBOX_ONLY_CHECK]: {
		cssClass: "checkbox",
		useScale: true,
		state: {
			activ: iconCheck,
			inactiv: iconCheck
		}
	},
	[ICON_CIRCLE]: {
		cssClass: "circle",
		useScale: true,
		state: {
			activ: iconCircle,
			inactiv: iconCircle
		}
	},
	[ICON_ADD]: {
		cssClass: "add-icon",
		state: {
			activ: iconPlus,
			activAn: `${iconPlus};${iconRhombusH};${iconPlus}`,
			inactiv: iconPlus,
			inActivAn: `${iconPlus};${iconRhombusH};${iconPlus}`
		}
	},
	[ICON_NEXT]: {
		cssClass: "next",
		state: {
			activ: iconArrowRight,
			activAn: `${iconArrowRight};${iconRhombusH};${iconArrowRight}`,
			inactiv: iconArrowRight,
			inActivAn: `${iconArrowRight};${iconRhombusH};${iconArrowRight}`
		}
	},
	[ICON_PREVIOUS]: {
		cssClass: "previousArrow",
		state: {
			activ: iconArrowLeft,
			activAn: `${iconArrowLeft};${iconRhombusH};${iconArrowLeft}`,
			inactiv: iconArrowLeft,
			inActivAn: `${iconArrowLeft};${iconRhombusH};${iconArrowLeft}`
		}
	},
	[ICON_STAR]: {
		cssClass: "next",
		state: {
			activ: iconStar,
			activAn: `${iconStar};${iconRhombusH};${iconStar}`,
			inactiv: iconStar,
			inActivAn: `${iconStar};${iconRhombusH};${iconStar}`
		}
	},
	[ICON_CAMERA]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <circle cx="12" cy="12" r="3.2"/>
                                  <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"/>
                                </svg>` },
	[ICON_DELETE_NEW]: { icon: () => svg`<svg viewBox="0 0 32 32">
        <path d="M10 24h4v-10h-4v10zM22 6v-2c0-2.208-1.792-4-4-4h-4c-2.208 0-4 1.792-4 4v2h-10v2c0 1.104 0.896 2 2 2v18c0 2.208 1.792 4 4 4h20c2.208 0 4-1.792 4-4v-18c1.106 0 2-0.896 2-2v-2h-10zM14 4h4v2h-4v-2zM26 26c0 1.106-0.894 2-2 2h-16c-1.104 0-2-0.894-2-2v-14c0-1.104 0.896-2 2-2h16c1.106 0 2 0.896 2 2v14zM18 24h4v-10h-4v10z"></path>
      </svg>` },
	[ICON_DELETE]: { icon: () => svg`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12z"/>
      </svg>` },
	[ICON_SETTINGS]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" />
                               </svg>` },
	[ICON_RULES]: { icon: (status) => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="${status} rules-icon">
              <rect x="48" y="87.5" width="70.51" height="80" />
              <rect x="160.81" y="87.5" width="303.19" height="80" />
              <rect x="48" y="216" width="70.51" height="80" />
              <rect x="160.81" y="216" width="303.19" height="80" />
              <rect x="48" y="344.5" width="70.51" height="80" />
              <rect x="160.81" y="344.5" width="303.19" height="80" />
          </svg>` },
	[ICON_USER]: { icon: () => svg`<svg class="userIcon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3.14,20.86V18.64c0-2.43,4-4.43,8.86-4.43s8.86,2,8.86,4.43v2.22ZM7.57,7.57A4.43,4.43,0,1,1,12,12,4.43,4.43,0,0,1,7.57,7.57Z" />
                                </svg>` },
	[ICON_USERS]: { icon: () => svg`<svg class="usersIcon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                                </svg>` },
	[ICON_CHAT]: { icon: () => svg`<svg class="chatIcon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4.5,3h15A2.5,2.5,0,0,1,22,5.5v9A2.5,2.5,0,0,1,19.5,17H9.9L5.2,20.75A.75.75,0,0,1,4,20.16V17H4.5A2.5,2.5,0,0,1,2,14.5v-9A2.5,2.5,0,0,1,4.5,3Z" />
                                </svg>` },
	[ICON_LEAVE]: { icon: (status) => svg`<svg xmlns="http://www.w3.org/2000/svg" class="leave-game ${status}" viewBox="0 0 512 512">
                      <path d="M233.29,304.11l-24.21,28.32H122.53a23.72,23.72,0,0,0,0,47.44h98.05a23.72,23.72,0,0,0,18.62-9l32.44-38.62Z" />
                      <path d="M475.12,255.77l-58.54-16-23.95-55.9c-3.8-8.87-38.31-35.7-45.33-38.25l-69.59-25.31a23.77,23.77,0,0,0-17.23.4l-75.91,31.63a23.73,23.73,0,1,0,18.25,43.8l67.37-28.08L296,177.51c-.2.43-.44.84-.63,1.28l-43.2,95.12c-6.21,14.31,2.44,26,13.51,37.1l66,48.52-42.71,96.11a23.72,23.72,0,1,0,43.35,19.27L383,361a23.71,23.71,0,0,0-8-29l-38.53-27.3a45.56,45.56,0,0,0,3.77-6.88l24.94-57.47L377.48,269a23.68,23.68,0,0,0,15.57,13.54l69.58,19a23.72,23.72,0,0,0,12.49-45.77Z" />
                      <circle cx="395.39" cy="101.86" r="46.6" />
                      <path d="M173.89,225h-108a5.4,5.4,0,1,1,0-10.8h108a5.4,5.4,0,0,1,0,10.8Z" />
                      <path d="M132.84,160.74H24.8a5.41,5.41,0,0,1,0-10.81h108a5.41,5.41,0,0,1,0,10.81Z" />
                      <path d="M190.1,96.46H90.7a5.41,5.41,0,0,1,0-10.81h99.4a5.41,5.41,0,0,1,0,10.81Z" />
                  </svg>` },
	[ICON_STAT]: { icon: () => svg`<svg class="stat-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.16,20.31V7.84h4.15V20.31Zm-6.24,0V3.69h4.16V20.31Zm-6.23,0V12H7.84v8.31Z" />
          </svg>` },
	[ICON_SYNC]: { icon: () => svg`<svg class="sync-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
              <path d="M29.594 15.875l-4.594-4.688-4.563 4.688h2.719v0.125q0 1.5-0.563 2.797t-1.531 2.281-2.281 1.547-2.813 0.563q-1.531 0-2.875-0.609t-2.313-1.641l-2.469 2.531q1.469 1.5 3.438 2.375t4.219 0.875q2.219 0 4.172-0.844t3.406-2.297 2.297-3.406 0.844-4.172v-0.125h2.906zM8.813 16.188v-0.188q0-1.5 0.563-2.797t1.531-2.281 2.281-1.547 2.781-0.563q1.563 0 2.922 0.609t2.328 1.672l2.469-2.531q-1.469-1.5-3.453-2.391t-4.266-0.891q-2.188 0-4.141 0.844t-3.406 2.297-2.297 3.406-0.844 4.172v0.188h-2.875l4.594 4.688 4.563-4.688h-2.75z"></path>
          </svg>` },
	[ICON_CLOUD_UPLOAD]: { icon: () => svg`<svg class="cloudUploadIcon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <!-- Classic glyph: dominant cloud, punched-out arrow (Material
           proportions, stretched for small-size readability). -->
      <path fill-rule="evenodd" d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM12 6.6l5.2 5.6H14v5.2h-4v-5.2H6.8Z" />
    </svg>` },
	[ICON_CLOUD_DOWNLOAD]: { icon: () => svg`<svg class="cloudDownloadIcon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <!-- Mirror of upload: punched-out arrow pointing down. -->
      <path fill-rule="evenodd" d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM12 17.8 6.8 12.2H10V7h4v5.2h3.2Z" />
    </svg>` },
	[ICON_DATE]: { icon: () => svg`<svg class="date-icon" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
              <path d="M27.2 4.8h-1.44v3.2h-5.12v-3.2h-9.28v3.2h-5.12v-3.2h-1.44c-1.76 0-3.2 1.44-3.2 3.2v19.2c0 1.76 1.44 3.2 3.2 3.2h22.4c1.76 0 3.2-1.44 3.2-3.2v-19.2c0-1.76-1.44-3.2-3.2-3.2zM27.2 27.2h-22.4v-12.8h22.4v12.8zM9.92 1.6h-2.24v5.44h2.24v-5.44zM24.32 1.6h-2.24v5.44h2.24v-5.44z"></path>
          </svg>` },
	[ICON_DATE_TIME]: { icon: () => svg`<svg class="date-icon" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">  
      <path d="M27.2 4.8h-1.44v3.2h-5.12v-3.2h-9.28v3.2h-5.12v-3.2h-1.44c-1.76 0-3.2 1.44-3.2 3.2v19.2c0 1.76 1.44 3.2 3.2 3.2h22.4c1.76 0 3.2-1.44 3.2-3.2v-19.2c0-1.76-1.44-3.2-3.2-3.2zM27.2 27.2h-22.4v-12.8h22.4v12.8zM9.92 1.6h-2.24v5.44h2.24v-5.44zM24.32 1.6h-2.24v5.44h2.24v-5.44z"></path>
      <circle cx="24.8" cy="24.8" r="8" stroke="var(--my-icon-fill-col)" fill="var(--pd-icon-inner-col, white)" stroke-width="2.2px" />
      <line x1="24.8" y1="24.8" x2="24.8" y2="19.5" stroke="var(--my-icon-fill-col)" stroke-width="2px" stroke-linecap="round" />
      <line x1="24.8" y1="24.8" x2="28.9" y2="24.8" stroke="var(--my-icon-fill-col)" stroke-width="2px" stroke-linecap="round" />
    </svg>` },
	[ICON_AVAILABILITY]: { icon: () => svg`<svg class="date-icon" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
      <!-- Calendar frame like ICON_DATE, body diagonally half filled
           (availability view motif: arrival day, second half occupied). -->
      <path d="M27.2 4.8h-1.44v3.2h-5.12v-3.2h-9.28v3.2h-5.12v-3.2h-1.44c-1.76 0-3.2 1.44-3.2 3.2v19.2c0 1.76 1.44 3.2 3.2 3.2h22.4c1.76 0 3.2-1.44 3.2-3.2v-19.2c0-1.76-1.44-3.2-3.2-3.2zM27.2 27.2h-22.4v-12.8h22.4v12.8zM9.92 1.6h-2.24v5.44h2.24v-5.44zM24.32 1.6h-2.24v5.44h2.24v-5.44z"></path>
      <path d="M27.2 14.4v12.8h-22.4z"></path>
    </svg>` },
	[ICON_CLOCK]: { icon: () => svg`<svg class="clockIcon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
    </svg>` },
	[ICON_DETAIL]: { icon: () => svg`<svg class="detail-icon" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 6c-6.979 0-13.028 4.064-16 10 2.972 5.936 9.021 10 16 10s13.027-4.064 16-10c-2.972-5.936-9.021-10-16-10zM23.889 11.303c1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303s-5.527-0.796-7.889-2.303c-1.88-1.199-3.473-2.805-4.67-4.697 1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 4.418 3.582 8 8 8s8-3.582 8-8c0-0.962-0.17-1.883-0.482-2.737 0.124 0.074 0.248 0.15 0.371 0.228zM16 12.813c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z"></path>
          </svg>` },
	[ICON_ERROR]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12,2.5c5.24,0,9.5,4.26,9.5,9.5s-4.26,9.5-9.5,9.5S2.5,17.24,2.5,12,6.76,2.5,12,2.5m0-2C5.65.5.5,5.65.5,12s5.15,11.5,11.5,11.5,11.5-5.15,11.5-11.5S18.35.5,12,.5h0Z" />
              <path d="m17.44,8.48l-1.92-1.92-3.52,3.52-3.52-3.52-1.92,1.92,3.52,3.52-3.52,3.52,1.92,1.92s1.84-1.84,3.52-3.52l3.52,3.52,1.92-1.92-3.52-3.52c1.68-1.68,3.52-3.52,3.52-3.52Z" />
          </svg>` },
	[ICON_ERROR_FLD]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12,.5C5.65.5.5,5.65.5,12s5.15,11.5,11.5,11.5,11.5-5.15,11.5-11.5S18.35.5,12,.5h0Z" />
              <path d="m17.44,8.48l-1.92-1.92-3.52,3.52-3.52-3.52-1.92,1.92,3.52,3.52-3.52,3.52,1.92,1.92s1.84-1.84,3.52-3.52l3.52,3.52,1.92-1.92-3.52-3.52c1.68-1.68,3.52-3.52,3.52-3.52Z"
                    fill="var(--pd-icon-inner-col, #fff)" />
          </svg>` },
	[ICON_HELP]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12,2.5c5.24,0,9.5,4.26,9.5,9.5s-4.26,9.5-9.5,9.5S2.5,17.24,2.5,12,6.76,2.5,12,2.5m0-2C5.65.5.5,5.65.5,12s5.15,11.5,11.5,11.5,11.5-5.15,11.5-11.5S18.35.5,12,.5h0Z" />
            <path d="m7.29,9.73c.06-2.74,1.86-4.73,4.65-4.73,3.62,0,4.77,2.22,4.77,3.7,0,1.86-.79,2.6-1.61,3.24-.82.61-1.7,1.11-1.88,2.24v.73h-2.59v-.86c.11-1.67.9-2.41,1.67-3.01.75-.59,1.4-1.03,1.4-2.07,0-1.17-.61-1.72-1.63-1.72-1.38,0-1.95,1.13-1.97,2.49,0,0-2.82,0-2.82,0Z" />
            <rect x="10.37" y="16.05" width="3.01" height="2.95" />
          </svg>` },
	[ICON_HELP_FLD]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12,.5C5.65.5.5,5.65.5,12s5.15,11.5,11.5,11.5,11.5-5.15,11.5-11.5S18.35.5,12,.5h0Z" />
              <path d="m7.29,9.73c.06-2.74,1.86-4.73,4.65-4.73,3.62,0,4.77,2.22,4.77,3.7,0,1.86-.79,2.6-1.61,3.24-.82.61-1.7,1.11-1.88,2.24v.73h-2.59v-.86c.11-1.67.9-2.41,1.67-3.01.75-.59,1.4-1.03,1.4-2.07,0-1.17-.61-1.72-1.63-1.72-1.38,0-1.95,1.13-1.97,2.49,0,0-2.82,0-2.82,0Z"
                      fill="var(--pd-icon-inner-col, #fff)" />
              <rect x="10.37" y="16.05" width="3.01" height="2.95" fill="var(--pd-icon-inner-col, #fff)" />
          </svg>` },
	[ICON_INFO]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m13.5,7.29h-3v-2.29h3v2.29h0Zm-3,1.57h3v10.14h-3s0-10.14,0-10.14Z" />
              <path d="m12,2.5c5.24,0,9.5,4.26,9.5,9.5s-4.26,9.5-9.5,9.5S2.5,17.24,2.5,12,6.76,2.5,12,2.5m0-2C5.65.5.5,5.65.5,12s5.15,11.5,11.5,11.5,11.5-5.15,11.5-11.5S18.35.5,12,.5h0Z" />
          </svg>` },
	[ICON_INFO_FLD]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12,.5C5.65.5.5,5.65.5,12s5.15,11.5,11.5,11.5,11.5-5.15,11.5-11.5S18.35.5,12,.5h0Z" />
              <path d="m13.5,7.29h-3v-2.29h3v2.29h0Zm-3,1.57h3v10.14h-3s0-10.14,0-10.14Z" fill="var(--pd-icon-inner-col, #fff)" />
          </svg>` },
	[ICON_WARNING]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m11,17.54h2v1.64h-2v-1.64h0Zm2-1.12h-2v-7.24h2s0,7.24,0,7.24Z" />
              <path d="m21.92,22.49H2.08c-.35,0-.68-.18-.86-.48-.18-.3-.19-.67-.03-.98L11.27,2.04c.17-.33.49-.51.89-.53.37,0,.71.21.88.54l9.77,18.98c.16.31.15.68-.04.98s-.5.48-.85.48Zm-18.19-2h16.55L12.14,4.67,3.74,20.49Z" />
          </svg>` },
	[ICON_WARNING_FLD]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m21.92,22.49H2.08c-.35,0-.68-.18-.86-.48-.18-.3-.19-.67-.03-.98L11.27,2.04c.17-.33.49-.51.89-.53.37,0,.71.21.88.54l9.77,18.98c.16.31.15.68-.04.98s-.5.48-.85.48Z" />
              <path d="m11,17.54h2v1.64h-2v-1.64h0Zm2-1.12h-2v-7.24h2s0,7.24,0,7.24Z" fill="var(--pd-icon-inner-col, #fff)" />
          </svg>` },
	[ICON_BURGER_MENU]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"/>
          </svg>` },
	[ICON_DRAG_HANDLE]: { icon: () => svg`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <style>
          .drag-dot {
            animation: drag-wave 1000ms ease-out both;
          }
          .drag-dot.row-1 { animation-delay: 0ms; }
          .drag-dot.row-2 { animation-delay: 140ms; }
          .drag-dot.row-3 { animation-delay: 280ms; }
          @keyframes drag-wave {
            0% {
              r: 2.4;
              opacity: 1;
            }
            45% {
              r: 3.4;
              opacity: 0.7;
            }
            100% {
              r: 2.4;
              opacity: 1;
            }
          }
        </style>
      </defs>
      <circle class="drag-dot row-1" cx="8" cy="4" r="2.4" />
      <circle class="drag-dot row-1" cx="16" cy="4" r="2.4" />
      <circle class="drag-dot row-2" cx="8" cy="12" r="2.4" />
      <circle class="drag-dot row-2" cx="16" cy="12" r="2.4" />
      <circle class="drag-dot row-3" cx="8" cy="20" r="2.4" />
      <circle class="drag-dot row-3" cx="16" cy="20" r="2.4" />
    </svg>` },
	[ICON_EDIT]: { icon: () => svg`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
      </svg>` },
	[ICON_EDIT_NEW]: { icon: () => svg`<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="M28 32h-24c-2.208 0-4-1.792-4-4v-24c0-2.208 1.792-4 4-4h18l-4 4h-12c-1.104 0-2 0.896-2 2v20c0 1.106 0.896 2 2 2h20c1.106 0 2-0.894 2-2v-12l4-4v18c0 2.208-1.792 4-4 4zM28 4l-2-2v-2c0 0 6-0.062 6 6h-2l-2-2zM10 22v-6h2l4 4v2h-6zM28 8l-10 10-4-4 10-10 4 4z"></path>
      </svg> ` },
	[ICON_SEARCH]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
      <path d="M 21 3 C 11.6 3 4 10.6 4 20 C 4 29.4 11.6 37 21 37 C 24.354553 37 27.47104 36.01984 30.103516 34.347656 L 42.378906 46.621094 L 46.621094 42.378906 L 34.523438 30.279297 C 36.695733 27.423994 38 23.870646 38 20 C 38 10.6 30.4 3 21 3 z M 21 7 C 28.2 7 34 12.8 34 20 C 34 27.2 28.2 33 21 33 C 13.8 33 8 27.2 8 20 C 8 12.8 13.8 7 21 7 z"></path>
      </svg> ` },
	[ICON_PHONE]: { icon: () => svg`
        <svg viewBox="0 0 473.806 473.806" xmlns="http://www.w3.org/2000/svg">
          <g>
            <g>
              <path d="M374.456,293.506c-9.7-10.1-21.4-15.5-33.8-15.5c-12.3,0-24.1,5.3-34.2,15.4l-31.6,31.5c-2.6-1.4-5.2-2.7-7.7-4
                  c-3.6-1.8-7-3.5-9.9-5.3c-29.6-18.8-56.5-43.3-82.3-75c-12.5-15.8-20.9-29.1-27-42.6c8.2-7.5,15.8-15.3,23.2-22.8
                  c2.8-2.8,5.6-5.7,8.4-8.5c21-21,21-48.2,0-69.2l-27.3-27.3c-3.1-3.1-6.3-6.3-9.3-9.5c-6-6.2-12.3-12.6-18.8-18.6
                  c-9.7-9.6-21.3-14.7-33.5-14.7s-24,5.1-34,14.7c-0.1,0.1-0.1,0.1-0.2,0.2l-34,34.3c-12.8,12.8-20.1,28.4-21.7,46.5
                  c-2.4,29.2,6.2,56.4,12.8,74.2c16.2,43.7,40.4,84.2,76.5,127.6c43.8,52.3,96.5,93.6,156.7,122.7c23,10.9,53.7,23.8,88,26
                  c2.1,0.1,4.3,0.2,6.3,0.2c23.1,0,42.5-8.3,57.7-24.8c0.1-0.2,0.3-0.3,0.4-0.5c5.2-6.3,11.2-12,17.5-18.1c4.3-4.1,8.7-8.4,13-12.9
                  c9.9-10.3,15.1-22.3,15.1-34.6c0-12.4-5.3-24.3-15.4-34.3L374.456,293.506z M410.256,398.806
                  C410.156,398.806,410.156,398.906,410.256,398.806c-3.9,4.2-7.9,8-12.2,12.2c-6.5,6.2-13.1,12.7-19.3,20
                  c-10.1,10.8-22,15.9-37.6,15.9c-1.5,0-3.1,0-4.6-0.1c-29.7-1.9-57.3-13.5-78-23.4c-56.6-27.4-106.3-66.3-147.6-115.6
                  c-34.1-41.1-56.9-79.1-72-119.9c-9.3-24.9-12.7-44.3-11.2-62.6c1-11.7,5.5-21.4,13.8-29.7l34.1-34.1c4.9-4.6,10.1-7.1,15.2-7.1
                  c6.3,0,11.4,3.8,14.6,7c0.1,0.1,0.2,0.2,0.3,0.3c6.1,5.7,11.9,11.6,18,17.9c3.1,3.2,6.3,6.4,9.5,9.7l27.3,27.3
                  c10.6,10.6,10.6,20.4,0,31c-2.9,2.9-5.7,5.8-8.6,8.6c-8.4,8.6-16.4,16.6-25.1,24.4c-0.2,0.2-0.4,0.3-0.5,0.5
                  c-8.6,8.6-7,17-5.2,22.7c0.1,0.3,0.2,0.6,0.3,0.9c7.1,17.2,17.1,33.4,32.3,52.7l0.1,0.1c27.6,34,56.7,60.5,88.8,80.8
                  c4.1,2.6,8.3,4.7,12.3,6.7c3.6,1.8,7,3.5,9.9,5.3c0.4,0.2,0.8,0.5,1.2,0.7c3.4,1.7,6.6,2.5,9.9,2.5c8.3,0,13.5-5.2,15.2-6.9
                  l34.2-34.2c3.4-3.4,8.8-7.5,15.1-7.5c6.2,0,11.3,3.9,14.4,7.3c0.1,0.1,0.1,0.1,0.2,0.2l55.1,55.1
                  C420.456,377.706,420.456,388.206,410.256,398.806z"/>
              <path d="M256.056,112.706c26.2,4.4,50,16.8,69,35.8s31.3,42.8,35.8,69c1.1,6.6,6.8,11.2,13.3,11.2c0.8,0,1.5-0.1,2.3-0.2
                  c7.4-1.2,12.3-8.2,11.1-15.6c-5.4-31.7-20.4-60.6-43.3-83.5s-51.8-37.9-83.5-43.3c-7.4-1.2-14.3,3.7-15.6,11
                  S248.656,111.506,256.056,112.706z"/>
              <path d="M473.256,209.006c-8.9-52.2-33.5-99.7-71.3-137.5s-85.3-62.4-137.5-71.3c-7.3-1.3-14.2,3.7-15.5,11
                  c-1.2,7.4,3.7,14.3,11.1,15.6c46.6,7.9,89.1,30,122.9,63.7c33.8,33.8,55.8,76.3,63.7,122.9c1.1,6.6,6.8,11.2,13.3,11.2
                  c0.8,0,1.5-0.1,2.3-0.2C469.556,223.306,474.556,216.306,473.256,209.006z"/>
            </g>
          </g>
        </svg>
      ` },
	[ICON_AI_SPARKLE]: { icon: (active) => svg`<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <style>
          .sparkle-star {
            transform-origin: center;
            transform-box: fill-box;
          }
          .sparkling .star-1 {
            animation: sparkle-twinkle 700ms ease-in-out;
          }
          .sparkling .star-2 {
            animation: sparkle-twinkle 600ms ease-in-out 120ms both;
          }
          .sparkling .star-3 {
            animation: sparkle-twinkle 500ms ease-in-out 280ms both;
          }
          @keyframes sparkle-twinkle {
            0%   { transform: scale(1) rotate(0deg); opacity: 1; }
            20%  { transform: scale(0.2) rotate(-30deg); opacity: 0.2; }
            50%  { transform: scale(1.4) rotate(10deg); opacity: 1; }
            70%  { transform: scale(0.85) rotate(-3deg); opacity: 0.9; }
            100% { transform: scale(1) rotate(0deg); opacity: 1; }
          }
        </style>
      </defs>
      <g class="${active ? "sparkling" : ""}">
        <path class="sparkle-star star-1"
          d="M 9 3 Q 10.5 11.5 17 13 Q 10.5 14.5 9 23 Q 7.5 14.5 1 13 Q 7.5 11.5 9 3 Z" />
        <path class="sparkle-star star-2"
          d="M 18 1 Q 18.8 3.5 22 4.5 Q 18.8 5.5 18 8 Q 17.2 5.5 14 4.5 Q 17.2 3.5 18 1 Z" />
        <path class="sparkle-star star-3"
          d="M 19.5 15 Q 20.2 17.2 23 18 Q 20.2 18.8 19.5 21 Q 18.8 18.8 16 18 Q 18.8 17.2 19.5 15 Z" />
      </g>
    </svg>` },
	[ICON_COPY]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
    </svg>` },
	[ICON_ALIGN_LEFT]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <rect x="3" y="4" width="18" height="2" rx="0.5" />
      <rect x="3" y="9" width="12" height="2" rx="0.5" />
      <rect x="3" y="14" width="18" height="2" rx="0.5" />
      <rect x="3" y="19" width="14" height="2" rx="0.5" />
    </svg>` },
	[ICON_ALIGN_CENTER]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <rect x="3" y="4" width="18" height="2" rx="0.5" />
      <rect x="6" y="9" width="12" height="2" rx="0.5" />
      <rect x="3" y="14" width="18" height="2" rx="0.5" />
      <rect x="5" y="19" width="14" height="2" rx="0.5" />
    </svg>` },
	[ICON_ALIGN_RIGHT]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <rect x="3" y="4" width="18" height="2" rx="0.5" />
      <rect x="9" y="9" width="12" height="2" rx="0.5" />
      <rect x="3" y="14" width="18" height="2" rx="0.5" />
      <rect x="7" y="19" width="14" height="2" rx="0.5" />
    </svg>` },
	[ICON_LINK]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7a5 5 0 0 0 0 10h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4a5 5 0 0 0 0-10z" />
    </svg>` },
	[ICON_CODE]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0L19.2 12l-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
    </svg>` },
	[ICON_CODE_BLOCK]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H4V5h16v14z" />
      <path d="M9.4 15.6L5.8 12l3.6-3.6L8 7l-5 5 5 5 1.4-1.4zm5.2 0L18.2 12l-3.6-3.6L16 7l5 5-5 5-1.4-1.4z" />
    </svg>` },
	[ICON_BLOCKQUOTE]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M6 17h3l2-4V7H5v6h3l-2 4zm8 0h3l2-4V7h-6v6h3l-2 4z" />
    </svg>` },
	[ICON_HORIZONTAL_RULE]: { icon: () => svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <rect x="3" y="11" width="18" height="2" rx="0.5" />
    </svg>` },
	/**
	* Auge-Icon zum Ein-/Ausblenden von Passwörtern.
	* `activeIcon` = true bedeutet "Passwort ist sichtbar" und zeigt daher das
	* durchgestrichene Auge (= Klick verbirgt wieder).
	*/
	[ICON_EYE]: { icon: (revealed) => revealed ? svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eye-icon">
            <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
          </svg>` : svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eye-icon">
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
          </svg>` },
	[ICON_MAIL]: { icon: () => svg`
        <svg viewBox="0 0 483.3 483.3" xmlns="http://www.w3.org/2000/svg">
          <g>
            <g>
              <path d="M424.3,57.75H59.1c-32.6,0-59.1,26.5-59.1,59.1v249.6c0,32.6,26.5,59.1,59.1,59.1h365.1c32.6,0,59.1-26.5,59.1-59.1
                  v-249.5C483.4,84.35,456.9,57.75,424.3,57.75z M456.4,366.45c0,17.7-14.4,32.1-32.1,32.1H59.1c-17.7,0-32.1-14.4-32.1-32.1v-249.5
                  c0-17.7,14.4-32.1,32.1-32.1h365.1c17.7,0,32.1,14.4,32.1,32.1v249.5H456.4z"/>
              <path d="M304.8,238.55l118.2-106c5.5-5,6-13.5,1-19.1c-5-5.5-13.5-6-19.1-1l-163,146.3l-31.8-28.4c-0.1-0.1-0.2-0.2-0.2-0.3
                  c-0.7-0.7-1.4-1.3-2.2-1.9L78.3,112.35c-5.6-5-14.1-4.5-19.1,1.1c-5,5.6-4.5,14.1,1.1,19.1l119.6,106.9L60.8,350.95
                  c-5.4,5.1-5.7,13.6-0.6,19.1c2.7,2.8,6.3,4.3,9.9,4.3c3.3,0,6.6-1.2,9.2-3.6l120.9-113.1l32.8,29.3c2.6,2.3,5.8,3.4,9,3.4
                  c3.2,0,6.5-1.2,9-3.5l33.7-30.2l120.2,114.2c2.6,2.5,6,3.7,9.3,3.7c3.6,0,7.1-1.4,9.8-4.2c5.1-5.4,4.9-14-0.5-19.1L304.8,238.55z"/>
            </g>
          </g>
        </svg>
      ` }
};
//#endregion
export { ALL_ICONS, EMPTY_POLYGON, ICON_ADD, ICON_AI_SPARKLE, ICON_ALIGN_CENTER, ICON_ALIGN_LEFT, ICON_ALIGN_RIGHT, ICON_ARROW_BACK, ICON_ARROW_DOWN, ICON_ARROW_NEXT, ICON_ARROW_UP, ICON_AVAILABILITY, ICON_BLOCKQUOTE, ICON_BURGER_MENU, ICON_CAMERA, ICON_CANCEL, ICON_CHAT, ICON_CHECK, ICON_CHECKBOX, ICON_CHECKBOX_ONLY_CHECK, ICON_CIRCLE, ICON_CLOCK, ICON_CLOSE, ICON_CLOUD_DOWNLOAD, ICON_CLOUD_UPLOAD, ICON_CODE, ICON_CODE_BLOCK, ICON_COPY, ICON_DATE, ICON_DATE_TIME, ICON_DELETE, ICON_DELETE_NEW, ICON_DETAIL, ICON_DRAG_HANDLE, ICON_EDIT, ICON_EDIT_NEW, ICON_ERROR, ICON_ERROR_FLD, ICON_EYE, ICON_HELP, ICON_HELP_FLD, ICON_HORIZONTAL_RULE, ICON_INFO, ICON_INFO_FLD, ICON_LEAVE, ICON_LINK, ICON_MAIL, ICON_NEXT, ICON_PHONE, ICON_PREVIOUS, ICON_RULES, ICON_SEARCH, ICON_SETTINGS, ICON_STAR, ICON_STAT, ICON_SYNC, ICON_TOGGLE_COLLAPSE, ICON_TOOGLE_ARROW, ICON_USER, ICON_USERS, ICON_WARNING, ICON_WARNING_FLD, ICON_XCLOSE, iconset, iconset_exports };
